<template>
  <div class="row">
    <div class="col-12">
      <portlet>
        <template slot="footer">
          <div class="row justify-content-center pt-4 pb-4">
            <bootstrap-pagination
              v-if="pagesGetter.page_total > 1"
              :total-page-number="pagesGetter.page_total"
              @number:updated="updateRecruitmentPage"
            />
          </div>
        </template>
        <div class="row justify-content-end">
          <div class="col-sm-2 col-6">
            <form-select
              :default-value="currentYear"
              :options="lastFiveYearsOptions"
              name="years"
              @change="yearSelected"
            />
          </div>
        </div>
        <table-wrapper>
          <table-row>
            <table-heading>
              活動名稱
            </table-heading>
            <table-heading :cols="2" />
          </table-row>
          <template v-if="enterpriseRecruitmentsGetter.length">
            <table-row
              v-for="recruitment in enterpriseRecruitmentsGetter"
              :key="recruitment.recruitment_id"
              programmatic-navigation
            >
              <table-data>
                {{ recruitment.recruitment_name }}
              </table-data>
              <table-data
                :cols="5"
                class="text-right"
              >
                <button-wrapper
                  class="d-none d-sm-inline-block"
                  @click="viewRecruitmentDetails($event, recruitment.recruitment_id)"
                >
                  查看活動內容
                </button-wrapper>
                <button-wrapper
                  class="d-sm-none"
                  @click="viewRecruitmentDetails($event, recruitment.recruitment_id)"
                >
                  查看
                </button-wrapper>
              </table-data>
            </table-row>
          </template>
          <table-row
            v-else
          >
            <table-data>
              今年尚未報名活動
            </table-data>
          </table-row>
        </table-wrapper>
      </portlet>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import Portlet from '~components/common/Portlet'
import TableWrapper from '~components/common/tables'
import TableRow from '~components/common/tables/Row'
import TableHeading from '~components/common/tables/Heading'
import TableData from '~components/common/tables/Data'
import ButtonWrapper from '~components/common/buttons'
import FormSelect from '~components/common/form/Select'
import BootstrapPagination from '~bootstrap/Pagination'
import { YearsStartFrom2019AndLimitFive } from '~/utils/date-time'
export default {
  name: 'EnrolledEvents',
  components: {
    Portlet,
    TableWrapper,
    TableRow,
    TableHeading,
    TableData,
    ButtonWrapper,
    FormSelect,
    BootstrapPagination
  },
  data () {
    return {
      thisYear: this.$moment().format('YYYY'),
      currentYear: this.thisYear
    }
  },
  computed: {
    ...mapGetters('pages/enterprises', [
      'enterpriseRecruitmentsGetter',
      'pagesGetter'
    ]),
    lastFiveYearsOptions () {
      return YearsStartFrom2019AndLimitFive().map(year => {
        return {
          name: `${year}`,
          value: year
        }
      })
    }
  },
  async created () {
    await this.getAllCampusRecruitments()
  },
  methods: {
    ...mapActions('pages/enterprises', [
      'getAllCampusRecruitments'
    ]),
    yearSelected ({ name, value: year }) {
      console.log(year, 'year')
      this.currentYear = year
      this.getAllCampusRecruitments({
        year,
        page: 1
      })
    },
    viewRecruitmentDetails (e, id) {
      this.$router.push({
        path: `campus-recruiting/${id}/enterprise`,
        query: {
          tab: '報名紀錄'
        }
      })
    },
    updateRecruitmentPage (page) {
      this.getAllCampusRecruitments({
        year: this.currentYear,
        page
      })
    }
  }
}
</script>
